import { FilterAlt } from "@mui/icons-material";
import {
  Button,
  InputLabel,
  MenuItem,
  Select,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
} from "@mui/material";
// import axios from "axios";
import React, { useState } from "react";
import { useEffect } from "react";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import { ToastContainer, toast } from "react-toastify";
import BorderColorIcon from "@mui/icons-material/BorderColor";

import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import Paper from "@mui/material/Paper";

import FormControl from "@mui/material/FormControl";
import axiosInstance from "../../../config/axios";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 500,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

const ReturnAndRefund = () => {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(6);
  const [data, setData] = useState([]);
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const [status1, setStatus1] = useState("");
  const [id, setId] = useState(null);
  const [orderStatus, setOrderStatus] = useState("");
  const [remark, setRemark] = useState("");

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const ReturnAndRefundData = () => {
    axiosInstance
      .get(`api/admin/return-order-refund-list/?store_id&return_status`, {
        headers: {
          Token: localStorage.getItem("Token"),
        },
      })
      .then((response) => {
        setData(response?.data?.data);
        console.log("delivery data====>", response?.data?.data);
      })
      .catch((error) => {
        console.log("", error);
      });
  };
  useEffect(() => {
    ReturnAndRefundData();
  }, []);
  const editData = (event, ids, order_status) => {
    event.preventDefault();
    handleOpen();
    setStatus1(order_status);
    setId(ids);
  };

  function updateData() {
    const reqBody = {
      order_id: id,
      return_requested: status1,
      return_status: orderStatus,
      return_status_text: remark,
    };
    axiosInstance
      .post(`api/admin/return-order-status-update/`, reqBody, {
        headers: {
          Token: localStorage.getItem("Token"),
        },
      })
      .then((response) => {
        toast.success(response.data.message);
        setRemark("");
        setOrderStatus("");
        ReturnAndRefundData();
        handleClose();
      })
      .catch((error) => {
        console.log("", error);
      });
  }

  function updateData1() {
    const reqBody = {
      order_id: id,
      return_requested: status1,
      refund_status: orderStatus,
      refund_status_text: remark,
    };
    axiosInstance
      .post(`api/admin/return-order-status-update/`, reqBody, {
        headers: {
          Token: localStorage.getItem("Token"),
        },
      })
      .then((response) => {
        toast.success(response.data.message);
        setRemark("");
        setOrderStatus("");
        ReturnAndRefundData();
        handleClose();
      })
      .catch((error) => {
        console.log("", error);
      });
  }

  return (
    <>
      <div className="">
        <div className="flex justify-between">
          <div className="p-2">
            <p className="text-xl text-black font-bold">
              Return & Refund Management
            </p>
          </div>
          <div className="p-2 pt-3">
            <Modal
              open={open}
              onClose={handleClose}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <Box sx={style} className="!border-0 !rounded-xl">
                <Typography id="modal-modal-title" variant="h6" component="h6">
                  <div
                    className="!text-center underline underline-offset-4"
                    style={{ fontFamily: "'Poppins', sans-serif" }}
                  >
                    {status1 === true ? "Return Update" : "Refund Update"}
                  </div>
                </Typography>
                <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                  <div className="gap-y-3"></div>
                  <div className="gap-2">
                    <InputLabel
                      className="!mt-1 !text-gray-700"
                      style={{ fontFamily: "'Poppins', sans-serif" }}
                    >
                      <div className="text-sm my-1">Status :</div>
                    </InputLabel>
                    <FormControl fullWidth>
                      <Select
                        labelId="demo-simple-select-label"
                        size="small"
                        id="return_status"
                        name="return_status"
                        onChange={(event) => setOrderStatus(event.target.value)}
                      >
                        <MenuItem value={"Pending"}>Pending</MenuItem>
                        <MenuItem value={"Accepted"}>Accepted</MenuItem>
                        <MenuItem value={"Rejected"}>Rejected</MenuItem>
                        <MenuItem value={"Cancelled"}>Cancelled</MenuItem>
                        <MenuItem value={"Processing"}>Processing</MenuItem>
                        <MenuItem value={"Refunded"}>Refunded</MenuItem>
                      </Select>
                    </FormControl>
                    {status1 === true ? (
                      <>
                        <InputLabel
                          className=" !text-gray-700"
                          style={{ fontFamily: "'Poppins', sans-serif" }}
                        >
                          <div className="text-sm my-1">Return Remark :</div>
                        </InputLabel>
                        <TextField
                          variant="outlined"
                          className="!w-[100%] !mt-1 !placeholder:text-sm"
                          size="small"
                          id="return_status_text"
                          name="return_status_text"
                          onChange={(event) => setRemark(event.target.value)}
                        />
                      </>
                    ) : (
                      <>
                        <InputLabel
                          className=" !text-gray-700"
                          style={{ fontFamily: "'Poppins', sans-serif" }}
                        >
                          <div className="text-sm my-1">Refund Remark :</div>
                        </InputLabel>
                        <TextField
                          variant="outlined"
                          className="!w-[100%] !mt-1 !placeholder:text-sm"
                          size="small"
                          id="return_status_text"
                          name="return_status_text"
                          onChange={(event) => setRemark(event.target.value)}
                        />
                      </>
                    )}
                  </div>
                  <div className="justify-between items-center ">
                    <Button
                      className="float-left top-3"
                      variant="contained"
                      color="warning"
                      onClick={handleClose}
                    >
                      CANCEL
                    </Button>

                    {status1 === true ? (
                      <Button
                        variant="contained"
                        color="success"
                        className="float-right top-3 mr-3"
                        onClick={updateData}
                      >
                        UPDATE
                      </Button>
                    ) : (
                      <Button
                        variant="contained"
                        color="success"
                        className="float-right top-3 mr-3"
                        onClick={updateData1}
                      >
                        UPDATE
                      </Button>
                    )}
                  </div>
                </Typography>
              </Box>
            </Modal>
          </div>
        </div>
        <div className="flex flex-col !rounded bg-secondary border-secondary shadow-card shadow-zinc-600 m-2">
          <div className="flex items-center bg-gray-100 rounded py-2">
            <div>
              <input type="text" className="border border-black" />
            </div>
          </div>
          <TableContainer
            component={Paper}
            sx={{ width: "100%", maxHeight: 440 }}
            className="!text-black !mx-auto !bg-white overflow-auto px-2"
          >
            <Table stickyHeader aria-label="sticky table" size="small">
              <TableHead>
                <TableRow>
                  <TableCell
                    style={{
                      borderRight: "1px solid #D0D0D0",
                      fontFamily: "'Poppins', sans-serif",
                    }}
                    className="!text-center !text-gray-800 !w-28 !font-bold"
                  >
                    ORDER ID
                  </TableCell>
                  <TableCell
                    style={{
                      borderRight: "1px solid #D0D0D0",
                      fontFamily: "'Poppins', sans-serif",
                    }}
                    className="!text-center !text-gray-800 !w-40 !font-bold"
                  >
                    RETURN STATUS
                  </TableCell>
                  <TableCell
                    style={{
                      borderRight: "1px solid #D0D0D0",
                      fontFamily: "'Poppins', sans-serif",
                    }}
                    className="!text-center !text-gray-800 !w-40 !font-bold"
                  >
                    REFUND STATUS
                  </TableCell>
                  <TableCell
                    style={{
                      borderRight: "1px solid #D0D0D0",
                      fontFamily: "'Poppins', sans-serif",
                    }}
                    className="!text-center !text-gray-800 !w-48 !font-bold"
                  >
                    RETURN STATUS
                  </TableCell>
                  <TableCell
                    style={{
                      borderRight: "1px solid #D0D0D0",
                      fontFamily: "'Poppins', sans-serif",
                    }}
                    className="!text-center !text-gray-800 !w-48 !font-bold"
                  >
                    REFUND STATUS
                  </TableCell>

                  <TableCell
                    style={{
                      borderRight: "1px solid #D0D0D0",
                      fontFamily: "'Poppins', sans-serif",
                    }}
                    className="!text-center !text-gray-800 !w-36 !font-bold"
                  >
                    RETURN REQUEST DATE
                  </TableCell>
                  <TableCell
                    style={{
                      borderRight: "1px solid #D0D0D0",
                      fontFamily: "'Poppins', sans-serif",
                    }}
                    className="!text-center !text-gray-800 !w-36 !font-bold"
                  >
                    REFUND REQUEST DATE
                  </TableCell>
                  <TableCell
                    style={{
                      borderRight: "1px solid #D0D0D0",
                      fontFamily: "'Poppins', sans-serif",
                    }}
                    className="!text-center !text-gray-800 !font-bold"
                  >
                    CUSOTMER REASION
                  </TableCell>
                  <TableCell
                    style={{
                      fontFamily: "'Poppins', sans-serif",
                    }}
                    className="!text-center !text-gray-800 !font-bold"
                  >
                    RETURN/REFUND <br />
                    UPDATE
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {data &&
                  data?.map((row) => (
                    <TableRow className="!cursor-pointer">
                      <TableCell
                        className="!text-center !text-[12px]"
                        style={{
                          borderRight: "1px solid #D0D0D0",
                          fontFamily: "'Poppins', sans-serif",
                        }}
                      >
                        {row?.sales_order?.reference_no
                          ? row?.sales_order?.reference_no
                          : "--"}
                      </TableCell>
                      <TableCell
                        className="!text-center !text-[12px]"
                        style={{
                          borderRight: "1px solid #D0D0D0",
                          fontFamily: "'Poppins', sans-serif",
                        }}
                      >
                        {row?.return_status ? row?.return_status : "--"}
                      </TableCell>
                      <TableCell
                        className="!text-center !text-[12px]"
                        style={{
                          borderRight: "1px solid #D0D0D0",
                          fontFamily: "'Poppins', sans-serif",
                        }}
                      >
                        {row?.refund_status ? row?.refund_status : "--"}
                      </TableCell>
                      <TableCell
                        className="!text-center !text-[12px]"
                        style={{
                          borderRight: "1px solid #D0D0D0",
                          fontFamily: "'Poppins', sans-serif",
                        }}
                      >
                        {row?.return_status_text
                          ? row?.return_status_text
                          : "--"}
                      </TableCell>
                      <TableCell
                        className="!text-center !text-[12px]"
                        style={{
                          borderRight: "1px solid #D0D0D0",
                          fontFamily: "'Poppins', sans-serif",
                        }}
                      >
                        {row?.refund_status_text
                          ? row?.refund_status_text
                          : "--"}
                      </TableCell>

                      <TableCell
                        className="!text-center !text-[12px]"
                        style={{
                          borderRight: "1px solid #D0D0D0",
                          fontFamily: "'Poppins', sans-serif",
                        }}
                      >
                        {row?.return_requested_date
                          ? row?.return_requested_date.slice(0, 10)
                          : "--"}
                      </TableCell>
                      <TableCell
                        className="!text-center !text-[12px]"
                        style={{
                          borderRight: "1px solid #D0D0D0",
                          fontFamily: "'Poppins', sans-serif",
                        }}
                      >
                        {row?.redund_requested_date
                          ? row?.redund_requested_date.slice(0, 10)
                          : "--"}
                      </TableCell>
                      <TableCell
                        className="!text-center !text-[12px]"
                        style={{
                          borderRight: "1px solid #D0D0D0",
                          fontFamily: "'Poppins', sans-serif",
                        }}
                      >
                        {row?.reason_for_return_choice?.choice
                          ? row?.reason_for_return_choice?.choice
                          : "--"}
                      </TableCell>
                      <TableCell
                        className="!text-center !text-[12px]"
                        style={{
                          fontFamily: "'Poppins', sans-serif",
                        }}
                      >
                        <BorderColorIcon
                          className="!text-green-400"
                          onClick={(event) =>
                            editData(event, row?.id, row?.return_requested)
                          }
                        />
                      </TableCell>
                    </TableRow>
                  ))}
              </TableBody>
            </Table>
            {data?.length !== 0 ? (
              <TablePagination
                rowsPerPageOptions={[6]}
                count={data?.length}
                component="div"
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
              />
            ) : null}
          </TableContainer>
        </div>
      </div>
    </>
  );
};

export default ReturnAndRefund;
